/*
Laminate

--manufacturer <Manufacturer>
--manufacturerNumber <string>
--computerEaseNumber <string>
*/
import {
  certification,
  color,
  computerEaseNumber,
  length,
  manufacturer,
  manufacturerNumber,
  width
} from '@/modules/standardItems/schemas/baseFormFields'

export default [
  {
    key: 'thickness',
    value: 'thickness',
    type: 'select',
    default: 'Standard',
    classes: ['xs12', 'sm4', 'input--medium'],
    attributes: {
      autofocus: true,
      label: 'Thickness',
      class: ['input--dense'],
      cacheItems: true
    },
    values: ['v32', '050']
  },
  width({ classes: ['xs12', 'sm4', 'input--medium'] }),
  length({ classes: ['xs12', 'sm4', 'input--medium'] }),
  {
    key: 'type',
    value: 'type',
    type: 'select',
    required: true,
    default: 'Backer',
    classes: ['xs12', 'sm4'],
    attributes: {
      label: 'Type',
      required: true,
      class: ['input--dense']
    },
    values: ['Backer', 'Liner']
  },
  color({ classes: ['xs12', 'sm4'] }),
  certification({ classes: ['xs12', 'sm4'] }),
  manufacturer(),
  manufacturerNumber(),
  computerEaseNumber()
]
